module.exports = __webpack_public_path__ + "img/file_upload.098e97e6.svg";